var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53414 8.01386L0.304051 1.7836C-0.101393 1.37835 -0.101393 0.723109 0.304051 0.317856C0.709306 -0.0873972 1.36454 -0.0873972 1.7698 0.317856L8.00008 6.54812L14.2302 0.317856C14.6356 -0.0873972 15.2907 -0.0873972 15.6959 0.317856C16.1014 0.723109 16.1014 1.37835 15.6959 1.7836L9.46583 8.01386L15.6959 14.2441C16.1014 14.6494 16.1014 15.3046 15.6959 15.7099C15.494 15.912 15.2284 16.0136 14.963 16.0136C14.6977 16.0136 14.4323 15.912 14.2302 15.7099L8.00008 9.47961L1.7698 15.7099C1.56765 15.912 1.30229 16.0136 1.03693 16.0136C0.771564 16.0136 0.506205 15.912 0.304051 15.7099C-0.101393 15.3046 -0.101393 14.6494 0.304051 14.2441L6.53414 8.01386Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2e1e2c3c06cdd78889f760c97e677d60.svg";
export { ForwardRef as ReactComponent };